// Permisos RBAC de Cohorts, encendidos: sin las claves sembradas la pantalla se esconde
// (fail-closed), igual que Segmentos.

export const COHORTS_PERMISSIONS = {
    read: 'loan.cohort.read',
    write: 'loan.cohort.write',
} as const;

export const COHORTS_PERMISSIONS_ENFORCED = true;

export interface CohortsAbilities {
    canRead: boolean;
    canWrite: boolean;
}

/** Con `enforce: false` todo queda permitido; con `true` cada acción exige su clave. */
export function resolveCohortsAbilities(
    grantedPermissions: ReadonlySet<string>,
    enforce: boolean = COHORTS_PERMISSIONS_ENFORCED,
): CohortsAbilities {
    if (!enforce) return { canRead: true, canWrite: true };
    return {
        canRead: grantedPermissions.has(COHORTS_PERMISSIONS.read),
        canWrite: grantedPermissions.has(COHORTS_PERMISSIONS.write),
    };
}
